// Toda ligação é uma mensagem voice_call com data.provider = 'whatsapp'. É ela,
// chegando por message.created/updated, que toca o telefone e encerra a sessão.
// Em chamada de entrada, data.ring = { tier, user_ids } diz pra quem a camada
// atual toca (1 responsável, 2 time, 3 inbox inteira); o filtro é feito aqui.
import { useWhatsappCallsStore } from 'dashboard/stores/whatsappCalls';
import { outboundAnswered, remoteEnded } from './session';

const TERMINAL = ['completed', 'no-answer', 'failed'];

// Sem ring (mensagem anterior ao deploy): toca pra todos, como antes.
const ringsForMe = (ring, currentUserId) =>
  !ring || ring.tier === 3 || ring.user_ids.includes(currentUserId);

export function handleWhatsappCallMessage(message, currentUserId) {
  const data = message?.content_attributes?.data;
  if (message?.content_type !== 'voice_call' || data?.provider !== 'whatsapp')
    return;

  const store = useWhatsappCallsStore();
  const call = {
    callId: data.call_id,
    conversationId: message.conversation_id,
    inboxId: message.inbox_id,
    contactName: data.contact_name,
    direction: data.call_direction,
    tier: data.ring?.tier,
  };

  if (data.status === 'ringing' && data.call_direction === 'inbound') {
    if (ringsForMe(data.ring, currentUserId)) store.addIncoming(call);
    return;
  }

  store.removeIncoming(call.callId);
  const isMine = store.active?.callId === call.callId;
  if (!isMine) return;

  if (
    data.status === 'in-progress' &&
    store.active.direction === 'outbound' &&
    store.active.status === 'ringing'
  ) {
    outboundAnswered().catch(() => {});
  }
  if (TERMINAL.includes(data.status)) remoteEnded();
}
